<template>
  <div class="stop-summary">
    <div class="box">
      <div class="left"><div class="line"></div></div>
      <div class="right">
        <div>
          <div class="label on">{{ onStopName }}</div>
          <div class="label">{{ offStopName }}</div>
        </div>
        <div v-if="showNavi" class="col" @click="onGoNavi(orderInfo)">
          <img src="../../../assets/img-v2/ic_running_navi.png" class="icon" />
          <div class="desc">前往站点</div>
        </div>
      </div>
    </div>
    <NaviPopup v-model="isShowNaviType" @confirm="onConfirmNavi"></NaviPopup>
  </div>
</template>

<script>
import { isMiniprogram, baiduToMars, marsToBaidu } from "@/utils";
import NaviPopup, { NAVI_TYPE } from "./NaviPopup.vue";

export default {
  name: "StopSummary",
  components: {
    NaviPopup,
  },
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
    userPosInfo: {
      type: Object,
      default: null,
    },
    notOn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amapNaviUrl: "",
      bmapNaviUrl: "",
      isShowNaviType: false, // 是否显示选择导航方式
    };
  },
  computed: {
    onStopName() {
      let { onStopName = "上车站" } = this.orderInfo || {};
      return onStopName;
    },
    offStopName() {
      let { offStopName = "下车站" } = this.orderInfo || {};
      return offStopName;
    },
    showNavi() {
      return this.notOn && !isMiniprogram();
    },
  },
  methods: {
    // 点击去这里
    onGoNavi(info) {
      console.log("导航", info, this.userPosInfo);
      const { latitude: fromLat, longitude: fromLng, address } =
        this.userPosInfo || {};
      if (!fromLat || !fromLng) {
        this.$toast("定位中，请稍后");
        return;
      }
      let fromName = "当前位置";
      if (address) {
        fromName = address.city + address.district + address.street;
      }
      const { onStopLat: toLat, onStopLng: toLng, onStopName: toName } =
        info || {};
      if (!toLat || !toLng) return;
      let marsPos = baiduToMars(fromLng, fromLat);
      this.amapNaviUrl = `https://uri.amap.com/navigation?from=${marsPos.lng},${
        marsPos.lat
      },${encodeURIComponent(
        fromName
      )}&to=${toLng},${toLat},${encodeURIComponent(toName)}&callnative=1`;
      console.log("高德导航", { url: this.amapNaviUrl });
      // origin_region destination_region不能为空
      let { lng: bLng, lat: bLat } = marsToBaidu(toLng, toLat);
      this.bmapNaviUrl = `https://api.map.baidu.com/direction?origin=latlng:${fromLat},${fromLng}|name:${encodeURIComponent(
        fromName
      )}&destination=latlng:${bLat},${bLng}|name:${encodeURIComponent(
        toName
      )}&origin_region=${encodeURIComponent(
        "北京"
      )}&destination_region=${encodeURIComponent(
        "北京"
      )}&mode=driving&output=html&src=webapp.baidu.openAPIdemo`;
      console.log("百度导航", { url: this.bmapNaviUrl });
      this.isShowNaviType = true;
    },
    onConfirmNavi(type) {
      if (type === NAVI_TYPE.AMAP) {
        this.isShowNaviType = false;
        window.location.href =this.amapNaviUrl;
      }
      if (type === NAVI_TYPE.BMAP) {
        this.isShowNaviType = false;
        window.location.href =this.bmapNaviUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stop-summary {
  width: 100%;
  background: #ffffff;
  padding: 0 20px;

  .box {
    border-top: 1px dashed #eeeeee;
    display: flex;
    padding: 16px 0;
  }
  .left {
    position: relative;
    width: 8px;
    display: flex;
    justify-content: center;
    margin-right: 8px;

    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      background: #04b47c;
      border-radius: 50%;
      position: absolute;
      top: 7px;
      z-index: 1;
    }
    &::after {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      background: #006efa;
      border-radius: 50%;
      position: absolute;
      bottom: 7px;
      z-index: 1;
    }
  }
  .line {
    position: absolute;
    top: 11px;
    bottom: 11px;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .right {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }
  .on {
    margin-bottom: 12px;
  }
  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10px;
  }
  .icon {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
  }
  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    line-height: 14px;
    white-space: nowrap;
  }
}
</style>
